import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../redux/baseQuery";
import { 
    createItemOpeningStock, 
    listAllItemOpeningStock, 
    listItemwiseStockSummary, 
    listStockSummary,
    listItemwiseStockSummaryv2,
    listStockSummaryv2,
    ListStockSummaryQuery,
    ListStockSummaryQueryVariables,
    ListItemwiseStockSummaryQuery,
    ListItemwiseStockSummaryQueryVariables,
    ListStockSummaryv2Query,
    ListStockSummaryv2QueryVariables,
    ListItemwiseStockSummaryv2Query,
    ListItemwiseStockSummaryv2QueryVariables,
    CreateItemOpeningStockMutation,
    CreateItemOpeningStockMutationVariables,
    ListAllItemOpeningStockQuery,
} from "../../../graphql";
import { 
    ProcessedStockSummary,
    ProcessedItemWiseStockSummary,
} from "../types/graphql";

export const stockManagementApi = createApi({
    reducerPath: "stockManagementApi",
    baseQuery: baseQuery,
    tagTypes: ["listStockSummary", "listStockSummaryByItemId", "listItemOpeningStock", "listStockSummaryv2", "listItemwiseStockSummaryv2"],
    endpoints: (builder) => ({
        listStockSummary: builder.query<ProcessedStockSummary[], ListStockSummaryQueryVariables>({
            query: (variables) => ({ body: listStockSummary, variables }),
            keepUnusedDataFor: 300,
            providesTags: ["listStockSummary"],
        }),
        listStockSummaryv2: builder.query<ProcessedStockSummary[], ListStockSummaryv2QueryVariables>({
            query: (variables) => ({ body: listStockSummaryv2, variables }),
            keepUnusedDataFor: 300,
            providesTags: ["listStockSummaryv2"],
        }),
        listStockSummaryByItemId: builder.query<ProcessedItemWiseStockSummary[], ListItemwiseStockSummaryQueryVariables>({
            query: (variables) => ({ body: listItemwiseStockSummary, variables }),
            keepUnusedDataFor: 300,
            providesTags: ["listStockSummaryByItemId"],
        }),
        listItemwiseStockSummaryv2: builder.query<ProcessedItemWiseStockSummary[], ListItemwiseStockSummaryv2QueryVariables>({
            query: (variables) => ({ body: listItemwiseStockSummaryv2, variables }),
            keepUnusedDataFor: 300,
            providesTags: ["listItemwiseStockSummaryv2"],
        }),
        createItemOpeningStock: builder.mutation<CreateItemOpeningStockMutation, CreateItemOpeningStockMutationVariables>({
            query: (variables) => ({ body: createItemOpeningStock, variables }),
            invalidatesTags: ["listStockSummary", "listItemOpeningStock"],
        }),
        listItemOpeningStock: builder.query<ListAllItemOpeningStockQuery, void>({
            query: () => ({ body: listAllItemOpeningStock, variables: {} }),
            keepUnusedDataFor: 300,
            providesTags: ["listItemOpeningStock"],
        }),
    }),
});

export const {
    useListStockSummaryQuery,
    useListStockSummaryv2Query,
    useCreateItemOpeningStockMutation,
    useListStockSummaryByItemIdQuery,
    useListItemwiseStockSummaryv2Query,
    useListItemOpeningStockQuery
} = stockManagementApi;
